// src/bridges/appBridge.js
export function postToApp(message) {
    try {
        const payload = typeof message === "string" ? message : JSON.stringify(message);

        // iOS (WKWebView)
        if (window.webkit?.messageHandlers?.appBridge?.postMessage) {
            window.webkit.messageHandlers.appBridge.postMessage(payload);
        }

        // Android (ReactNative WebView)
        if (window.ReactNativeWebView?.postMessage) {
            window.ReactNativeWebView.postMessage(payload);
        }
    } catch (e) {
        console.warn("postToApp error", e);
    }
}

// 디바이스 토큰
export function sendToApp(type, payload = {}) {
    const msg = { type, payload };
    // iOS + Android 모두 postToApp 경유
    postToApp(msg);
}

// ✅ RN 스플래시 내리는 신호: 전역에서 딱 1번만 보냄
export function notifyWebLoadingDone(target) {
    try {
        // 이미 보냈으면 무시
        // if (window.__WM_WEB_LOADING_DONE_SENT__) return;
        // window.__WM_WEB_LOADING_DONE_SENT__ = true;

        sendToApp("WEB_LOADING_DONE", {
            target,
            ts: Date.now(),
        });
    } catch (e) {
        console.log("notifyWebLoadingDone error", e);
    }
}

export function requestPushToken() {
    sendToApp('GET_PUSH_TOKEN');
}


// NAV_STATE 송신 (context를 포함할 수 있음)
export function notifyNavState({
    isRoot = false,
    canGoBackInWeb = false,
    hasBlockingUI = false,
    needsConfirm = false,
    hint = "",
    context = null, // { title, scenario, count, at, ... }
} = {}) {
    const message = {
        type: "NAV_STATE",
        payload: { isRoot, canGoBackInWeb, hasBlockingUI, needsConfirm, hint },
    };
    if (context) {
        // 스펙에 영향 없이 확장 필드로 동봉 (앱은 그대로 패스스루 가능)
        message.payload.context = context;
    }
    postToApp(message);
}

// 앱 → 웹 메시지 수신 바인딩
export function addAppMessageListener(handler) {
    // alert(handler)
    const onDocMessage = (e) => {
        try {
            const raw = e?.data ?? e;
            const msg = typeof raw === "string" ? JSON.parse(raw) : raw;
            if (msg && typeof msg === "object") handler?.(msg, e);
        } catch { }
    };

    const onWindowMessage = (e) => {
        try {
            const raw = e?.data ?? e;
            const msg = typeof raw === "string" ? JSON.parse(raw) : raw;

            // 🔒 DevTools / 기타 확장 메시지 필터링
            if (raw?.source === "react-devtools-content-script") return;
            if (!msg || typeof msg.type !== "string") return;

            handler?.(msg, e);
        } catch { }
    };

    document.addEventListener("message", onDocMessage); // Android RN WebView
    window.addEventListener("message", onWindowMessage); // iOS / 일반 브라우저

    return () => {
        document.removeEventListener("message", onDocMessage);
        window.removeEventListener("message", onWindowMessage);
    };
}


